const wordList7 = [
  { "de": "tot", "pl": "martwy" },
  { "de": "die Eltern", "pl": "rodzice" },
  { "de": "die Mutter", "pl": "matka" },
  { "de": "der Vater", "pl": "ojciec" },
  { "de": "der Sohn", "pl": "syn" },
  { "de": "die Tochter", "pl": "córka" },
  { "de": "die Schwester", "pl": "siostra" },
  { "de": "der Bruder", "pl": "brat" },
  { "de": "die Großmutter", "pl": "babcia" },
  { "de": "der Großvater", "pl": "dziadek" },
  { "de": "die Tante", "pl": "ciocia" },
  { "de": "der Onkel", "pl": "wujek" },
  { "de": "das Geschwister", "pl": "rodzeństwo" },
  { "de": "der Freund", "pl": "chłopak, przyjaciel" },
  { "de": "die Freundin", "pl": "dziewczyna, przyjaciółka" },
  { "de": "ignorieren", "pl": "ignorować" },
  { "de": "lieben", "pl": "kochać" },
  { "de": "mögen", "pl": "lubić" },
  { "de": "nicht mehr", "pl": "nie lubią go, już nie" },
  { "de": "nerven", "pl": "denerwować kogoś" },
  { "de": "der Arzt", "pl": "lekarz" },
  { "de": "die Ärztin", "pl": "lekarka" },
  { "de": "der Beruf", "pl": "zawód" },
  { "de": "der Chef", "pl": "szef" },
  { "de": "die Chefin", "pl": "szefowa" },
  { "de": "der Kellner", "pl": "kelner" },
  { "de": "der Koch", "pl": "kucharz" },
  { "de": "der Lehrer", "pl": "nauczyciel" },
  { "de": "die Lehrerin", "pl": "nauczycielka" },
  { "de": "der Polizist", "pl": "policjant" },
  { "de": "der Rentner", "pl": "emeryt" },
  { "de": "der Taxifahrer", "pl": "taksówkarz" },
  { "de": "das Büro", "pl": "biuro" },
  { "de": "das Restaurant", "pl": "restauracja" },
  { "de": "der Goldfisch", "pl": "złota rybka" },
  { "de": "der Hamster", "pl": "chomik" },
  { "de": "der Hund", "pl": "pies" },
  { "de": "die Katze", "pl": "kot" },
  { "de": "der Papagei", "pl": "papuga" },
  { "de": "die Energie", "pl": "energia" },
  { "de": "der Müll", "pl": "śmieci" },
  { "de": "der Umweltschutz", "pl": "ochrona środowiska" },
  { "de": "das Wasser", "pl": "woda" },
  { "de": "anbauen", "pl": "uprawiać" },
  { "de": "die Demo", "pl": "demonstracja" },
  { "de": "einkaufen", "pl": "robić zakupy" },
  { "de": "kochen", "pl": "gotować" },
  { "de": "reparieren", "pl": "naprawiać" },
  { "de": "untersuchen", "pl": "badać" },
  { "de": "verkaufen", "pl": "sprzedawać" }
];

export default wordList7;
